module.exports = __webpack_public_path__ + "static/media/[Audio]2010-07-18-3.6b6ae7b2.md";